"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./../../scss/video-players/BCVideoPlayer.scss");
function BCVideoPlayer(_ref) {
  let {
    bcId,
    playerElId = 'bc-player',
    containerClosing = false,
    autoplay = false,
    mute = false,
    handleClosing = () => true,
    pauseVideo = false
  } = _ref;
  const videoPlayer = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  const latestVideoId = (0, _react.useRef)(bcId);
  const handleKeypress = e => {
    if (e.key === 'Escape') {
      e.preventDefault();
      handleClosing(e);
    }
  };
  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  const initializePlayer = (0, _react.useCallback)(() => {
    if (autoplay) videoPlayer.current.play();
    if (mute) videoPlayer.current.muted(true);
  }, [autoplay, mute]);
  (0, _react.useEffect)(() => {
    const addPlayer = () => {
      const accountId = process.env.REACT_APP_BC_ACCOUNTID;
      const playerId = process.env.REACT_APP_BC_PLAYERID;
      const embedId = process.env.REACT_APP_BC_EMBEDID;
      const playerHTML = "<video-js id=\"".concat(playerElId, "\" data-video-id=\"").concat(bcId, "\" data-account=\"").concat(accountId, "\" data-player=\"").concat(playerId, "\" data-embed=\"").concat(embedId, "\" controls></video-js>");
      wrapperRef.current.innerHTML = playerHTML;
      if (videoPlayer.current !== null) videoPlayer.current.dispose();
      const videoJsScript = document.getElementById("video-js-script");
      if (videoJsScript) videoJsScript.remove();
      const s = document.createElement("script");
      s.src = "https://players.brightcove.net/".concat(accountId, "/").concat(playerId, "_default/index.min.js");
      s.id = "video-js-script";
      document.body.appendChild(s);
      s.onload = () => {
        videoPlayer.current = window.bc(playerElId);
        videoPlayer.current.on("loadedmetadata", initializePlayer);
      };
    };
    const waitForPlayerEl = setInterval(() => {
      if (wrapperRef.current !== null) {
        clearInterval(waitForPlayerEl);
        addPlayer();
      }
    }, 100);
  }, [bcId, playerElId, initializePlayer]);
  (0, _react.useEffect)(() => {
    if (containerClosing && videoPlayer.current !== null) videoPlayer.current.pause();
  }, [containerClosing]);
  (0, _react.useEffect)(() => {
    if (latestVideoId.current !== bcId) latestVideoId.current = bcId;
  }, [bcId]);
  (0, _react.useEffect)(() => {
    var _videoPlayer$current;
    if (pauseVideo) (_videoPlayer$current = videoPlayer.current) === null || _videoPlayer$current === void 0 || _videoPlayer$current.pause();
  }, [pauseVideo]);
  if (bcId !== null && bcId !== undefined && bcId !== '') {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "video-player-wrapper",
      className: 'video-player__wrapper',
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeypress,
      ref: wrapperRef,
      key: bcId
    });
  } else {
    return null;
  }
}
var _default = exports.default = BCVideoPlayer;